import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowBack } from "@mui/icons-material";
import styles from "./GamesBackLink.module.css";

/**
 * "Alle spil" link back to the /games hub.
 *
 * The four dark-launched minigames each carry their own CSS-module copy of this. PowerStrikle
 * styles itself with inline styles and the Tier List with a plain stylesheet, so they share this
 * component rather than growing a third and fourth copy of the same rule.
 */
const GamesBackLink: React.FC<{ className?: string }> = ({ className }) => {
    const { t } = useTranslation("pages");
    return (
        <Link to="/games" className={className ? `${styles.backLink} ${className}` : styles.backLink}>
            <ArrowBack sx={{ fontSize: 18 }} />
            {t("gamesHub.back")}
        </Link>
    );
};

export default GamesBackLink;
